module.exports = __webpack_public_path__ + "static/media/sliderimage4.4c846646.jpg";